import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, firstValueFrom } from 'rxjs';

import { ConfigService } from './config.service';
import { ContactForm } from '../models/contact-form.model';
import { InquiryResponse } from '../models/inquiry.model';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private apiUrl = '';

  constructor(private configService: ConfigService, private http: HttpClient) {}

  async initializeService(): Promise<void> {
    const config = await firstValueFrom(this.configService.loadConfig());
    this.apiUrl = config.mainEndpoint;
  }

  submitContactForm(contactData: ContactForm): Observable<InquiryResponse> {
    if (!this.apiUrl) {
      throw new Error('API URL is not set. Call initializeService() before submitContactForm().');
    }

    return this.http.post<InquiryResponse>(`${this.apiUrl}/inquiries`, contactData);
  }
}
